import TagManagementComponent from 'components/desktop/StandingData/Tag/Management/TagManagementComponent';

const TagManagementContainer = () => {
	const renderContent = () => {
		return (
			<main className="container">
				<TagManagementComponent />
			</main>
		);
	};

	return <>{renderContent()}</>;
};

export default TagManagementContainer;
